export const CREATE_NEW_TEXT = 'Create new';
export const NEW_TEMPLATE_NAME = 'Untitled Template';
export const NEW_RECURRING_NAME = 'Untitled Recurring Card';
